// @flow strict

import * as React from 'react';

function StockCommandePage() {
    return (
        <div className="p-6">
            <h1 className="font-poppins font-semibold text-[18px] text-title mb-4">
                Gestion du Stock et Commandes
            </h1>
            <p className="font-nunito text-[14px] text-text">
                Gérez votre inventaire et suivez vos commandes en temps réel.
            </p>
        </div>
    );
};

export default StockCommandePage;